import React, { useContext } from 'react';
import { StorageProviderKey } from '../../models/storageProviderKeys';
import { DropboxContext } from '../../services/dropbox/dropboxService';
import { GoogleApiContext, GoogleScope } from '../../services/gapi/gapiService';
import { OneDriveContext } from '../../services/oneDrive/oneDriveService';
import { Context } from '../../services/_globalContext/context';
import AuthorizeButton from '../common/authorizeButton/authorizeButton';
interface Props {
  setup?: boolean;
}

export default function ProviderList({
  setup,
}: Props) {

  const ctx = useContext(Context);
  const gapiCtx = useContext(GoogleApiContext);
  const oneDriveCtx = useContext(OneDriveContext);
  const dbxCtx = useContext(DropboxContext);

  // Google Identity Services issues access tokens and nothing else - there is
  // no profile behind this any more, so no email to show without spending an
  // extra scope and a userinfo request on it.
  const googleAccount = gapiCtx.getAccount();
  const oneDriveAccount = oneDriveCtx.isAuthenticated && oneDriveCtx.getAccount();

  return (
    <ul>
      <li>
        {gapiCtx.authorizedScopes.indexOf(GoogleScope.AppData) !== -1 ?
          <>
            <p>Google account connected{googleAccount ? '' : ' (authorisation expired)'}</p>
            <div className="button-group align-center">
              <button
                className="button"
                onClick={gapiCtx.logout}
              >
                Google Logout
              </button>
              <button
                className="button"
                onClick={() => ctx.configureStorageProvider(StorageProviderKey.GoogleDrive)}
              >
                Set as storage provider
              </button>
            </div>
          </>
          :
          <AuthorizeButton
            google
            busy={gapiCtx.isAuthorizing}
            onClick={setup
              ? () =>
                gapiCtx.authorize({
                  scope: GoogleScope.AppData,
                  allowRedirect: true,
                  // Carries the same instruction as the .then below, for the
                  // redirect path where the .then never runs.
                  intent: { configureProvider: true },
                }).then(
                  () => ctx.configureStorageProvider(StorageProviderKey.GoogleDrive),
                  ctx.callSnackbar,
                )
              : () => gapiCtx.authorize({
                scope: GoogleScope.AppData,
                allowRedirect: true,
              }).catch(ctx.callSnackbar)
            }
          />
        }
      </li>
      <br />
      <li>
        {oneDriveAccount ?
          <>
            <p>OneDrive Account {oneDriveAccount.username}</p>
            <div className="button-group align-center">
              <button
                className="button"
                onClick={oneDriveCtx.logout}
              >
                OneDrive Logout
              </button>

              <button
                className="button"
                onClick={() => ctx.configureStorageProvider(StorageProviderKey.OneDrive)}
              >
                Set as storage provider
              </button>
            </div>
          </>
          :
          <AuthorizeButton
            busy={oneDriveCtx.isAuthorizing}
            onClick={setup
              ? () =>
                oneDriveCtx.authorize({
                  allowRedirect: true,
                  // Carries the same instruction as the .then below, for the
                  // redirect path where the .then never runs.
                  intent: { configureProvider: true },
                }).then(
                  () => ctx.configureStorageProvider(StorageProviderKey.OneDrive),
                  ctx.callSnackbar,
                )
              : () => oneDriveCtx.authorize({ allowRedirect: true }).catch(ctx.callSnackbar)
            }
          >
            OneDrive Authorize
          </AuthorizeButton>
        }
      </li>
      <br />
      <li>
        {dbxCtx.account ?
          <>
            <p>Dropbox Account {dbxCtx.account.email}</p>
            <div className="button-group align-center">
              <button
                className="button"
                onClick={dbxCtx.logout}
              >
                Dropbox Logout
              </button>
              <button
                className="button"
                onClick={() => ctx.configureStorageProvider(StorageProviderKey.Dropbox)}
              >
                Set as storage provider
              </button>
            </div>
          </>
          :
          <AuthorizeButton
            busy={dbxCtx.isAuthorizing}
            onClick={setup
              ? () =>
                dbxCtx.authorize({
                  allowRedirect: true,
                  // Carries the same instruction as the .then below, for the
                  // redirect path where the .then never runs.
                  intent: { configureProvider: true },
                }).then(
                  () => ctx.configureStorageProvider(StorageProviderKey.Dropbox),
                  ctx.callSnackbar,
                )
              : () => dbxCtx.authorize({ allowRedirect: true }).catch(ctx.callSnackbar)
            }
          >
            Dropbox Authorize
          </AuthorizeButton>
        }
      </li>
    </ul>
  );
}
